import React, { Component } from "react";
import { alertActions } from '../../action/AlertAction';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { accountActions } from "../../action/AccountAction";
import { commonClass } from "../../helpers/commonClass";
import { Helmet } from "react-helmet";
// import countrycode from '../Home/countrycode.json';

class Profile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            player_name: '',
            phone_no: '',
            last_name: '',
            email: '',
            city: '',
            // country_code: countrycode,
            country_code: [],
            dob: '',
            password: '',
            saveSuccess: false,
            regUserid: "",
            // Ccname: countrycode.default.Ccname,
            // mobnoLength: countrycode.default.mobNolength,
            // setCountryFlag: countrycode.default.flag,
            // setCountryCode: countrycode.default.code,
            Ccname: '',
            mobnoLength: '',
            setCountryFlag: '',
            setCountryCode: '',
            serverDate: new Date(),
            ErrorFirstname: "",
            ErrorLastname: "",
            ErrorDob: "",
            Erroremail: "",
            honorifics: ""
        };

        props.GetProfile(this.props.user.mobileNo, this.props.i18n.language, this.props.user.loginKey, this.props.user.Country_code)
    }
    static getDerivedStateFromProps(props, state) {
        return { details: props.details }
    }
    componentDidMount() {
        this.GetCountryList()
        window.datepic((this.state.details && this.state.details.dob) ? this.state.details.dob : this.state.serverDate);
        document.getElementById("date-time1").value = (this.state.details ? this.state.details.dob : "");
        this.state.dob = document.getElementById("date-time1").value;
        this.toggleVal()
        // localStorage.setItem('atabId', 1); this code is using in Account Component
    };
    toggleVal = () => {
        window.setCountryToggleReg();
    };
    componentDidUpdate(prevProps, prevState) {
        if (this.state.phone_no == "" && this.state.details && this.state.saveSuccess == false) {
            this.setState({
                player_name: this.state.details.player_name,
                phone_no: this.state.details.phone_no,
                last_name: this.state.details.last_name,
                email: this.state.details.email,
                city: this.state.details.city,
                setCountryCode: this.state.details.country_code,
                dob: this.state.details.dob,
                submitted: false,
                saveSuccess: true,
                mobnoLength: this.state.details.phone_no.length,
                regUserid: this.state.details.user_id,
                honorifics: this.state.details.honorifics
            })
            let Country = this.state.country_code && this.state.country_code.other && this.state.country_code.other.filter(jsonobj => jsonobj.flag == this.state.details.country_code)
            if (Country == undefined || Country.length == 0) {
                this.state.Ccname = "";
            }
            else {
                this.state.Ccname = Country[0].Ccname;
            }
            window.datepic((this.state.details && this.state.details.dob) ? this.state.details.dob : this.state.serverDate);
            document.getElementById("date-time1").value = (this.state.details ? this.state.details.dob : "");
            this.state.dob = document.getElementById("date-time1").value;
        }
    }
    // ProfileUpdate = (e) => {
    //     e.preventDefault();
    //     if (this.isDate21orMoreYearsOld(document.getElementById("date-time1").value)) {
    //         this.state.dob = document.getElementById("date-time1").value;
    //         this.setState({ submitted: true })
    //         let { player_name, phone_no, last_name, email, city, country_code, dob, regUserid } = this.state;
    //         if (player_name && phone_no && last_name && email && country_code && dob && regUserid) {
    //             if (player_name.length <= 2) {
    //                 this.showMsg('lblFnamelength');
    //             }
    //             else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
    //                 this.showMsg('lblEnterValidEmail')
    //             }
    //             else {
    //                 let DobTemp = document.getElementById("date-time1").value;
    //                 this.setState({ saveSuccess: false });
    //                 player_name = player_name[0].toUpperCase() + player_name.slice(1);
    //                 last_name = last_name[0].toUpperCase() + last_name.slice(1);
    //                 this.props.UpdateProfile('profile-1', player_name, last_name, email, "000000000", DobTemp, city, document.getElementsByClassName("countryImg")[0].innerText, phone_no, this.props.user.mobileNo, this.props.i18n.language, this.props.user.loginKey)
    //             }
    //         }
    //         else {
    //             this.showMsg('lblPleaseFillDet');
    //         }
    //     }
    //     else { this.showMsg('lblEnterValidDate'); }
    // }


    ProfileUpdate = (e) => {
        e.preventDefault();
        const dobValue = document.getElementById("date-time1").value;
        // Step 1: Validate DOB
        let validationflag = true;

        this.setState({ submitted: true });
        this.state.dob = dobValue; // You should avoid directly modifying state like this

        // Step 2: Destructure values from state
        let { player_name, phone_no, last_name, email, city, country_code, regUserid } = this.state;
        if (!email) {
            this.showMsg('lblPleaseEnterEmail', 4);
            validationflag = false;
        }
        const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
        if (!emailRegex.test(email) && validationflag == true) {
            this.showMsg('lblEnterValidEmail', 4);
            validationflag = false;
        }
        if (!player_name || player_name.length <= 2) {
            this.showMsg('lblFnamelength', 1);
            validationflag = false;
        }
        if (!last_name || last_name.length <= 1) {
            this.showMsg('lblEnterLastname', 2);
            validationflag = false;
        }
        if (!this.isDate21orMoreYearsOld(dobValue)) {
            this.showMsg('lblEnterValidDate', 3);
            validationflag = false;
        }

        if (validationflag) {
            this.setErrorMessage(1, "")
            this.setErrorMessage(2, "")
            this.setErrorMessage(3, "")
            this.setErrorMessage(4, "")
            // All validations passed
            let capitalizedFirstName = player_name[0].toUpperCase() + player_name.slice(1);
            let capitalizedLastName = last_name[0].toUpperCase() + last_name.slice(1);
            let countryName = document.getElementsByClassName("countryImg")[0].innerText;
            this.setState({ saveSuccess: false });
            this.props.UpdateProfile(
                'profile-1',
                capitalizedFirstName,
                capitalizedLastName,
                email,
                "000000000",
                dobValue,
                city,
                countryName,
                phone_no,
                this.props.user.mobileNo,
                this.props.i18n.language,
                this.props.user.loginKey,
                this.state.honorifics
            );
        }
    }


    SetEmpty = () => {
        this.setState({ ErrorFirstname: "" })
        this.setState({ ErrorLastname: "" })
        this.setState({ ErrorDob: "" })
        this.setState({ Erroremail: "" })
    }


    isDate21orMoreYearsOld = (birthday) => {
        var lst = birthday.split('/');
        var optimizedBirthday = lst[2] + "/" + lst[1] + "/" + lst[0];
        var myBirthday = new Date(optimizedBirthday + ' 01:00:00');
        var currentDate = new Date().toJSON().slice(0, 10) + ' 01:00:00';
        var myAge = ~~((Date.now(currentDate) - myBirthday) / (31557600000));
        if (myAge <= 18) {
            return false;
        } else {
            return true;
        }
    }


    toggleCountry = () => {
        window.setCountryToggle();
    }
    countryChange = (lMobnolength, lcode, lflag) => {
        this.setState({ mobnoLength: lMobnolength, setCountryCode: lcode, setCountryFlag: lflag });
        window.setCountryToggle();
    }
    handleChange = (e) => {
        this.SetEmpty()
        let name = e.target.name;
        let value = e.target.value;
        if (name.toLowerCase().includes("phoneno") && value && (/^[0-9\b]+$/.test(value)) == false) { return; }
        else if ([e.target.name] == "player_name" || [e.target.name] == "last_name") {
            const regex = /^[a-zA-Z ]*$/;
            if (!regex.test(value) && !value == '') { return; }
            // value = value.replace(/[^A-Za-z]/ig, '')
        }
        this.setState({ [name]: value });
    }

    showMsg = (msg, flagNo) => {
        let errorstring = this.props.t(msg)
        if (flagNo > 0) {
            this.setErrorMessage(flagNo, errorstring)
        }
        else {
            this.props.alertError(errorstring);
        }
    }


    setErrorMessage = (flagNo, errorstring) => {
        switch (flagNo) {
            case 1:
                this.setState({ ErrorFirstname: errorstring })
                break;
            case 2:
                this.setState({ ErrorLastname: errorstring })
                break;
            case 3:
                this.setState({ ErrorDob: errorstring })
                break;
            case 4:
                this.setState({ Erroremail: errorstring })
                break;
            default:
                break;
        }
    }

    GetCountryList = () => {
        let new_Version = 0;
        let Version_old = localStorage.getItem('countryver');
        if (this.props.appvariables && this.props.appvariables.bVersion) {
            let totalversion = this.props.appvariables.bVersion.split("~")
            if (totalversion.length > 0) {
                new_Version = totalversion[3];
            }
        }
        if (Version_old != new_Version) {
            commonClass.GetCountry(new_Version)
                .then(response =>
                    response.json()
                )
                .then(data => {
                    localStorage.setItem('countryver', new_Version);
                    localStorage.setItem('countrylst', JSON.stringify(data));
                    this.setState({ country_code: data })
                });
        }
        else {
            let CountryList = JSON.parse(localStorage.getItem('countrylst')); // get from localstorage for countrylist
            this.setState({ country_code: CountryList })
        }
    }
    fstNameVal = (val) => {
        this.setState({ honorifics: val })
        window.setCountryToggleReg()
    }
    render() {
        const { t } = this.props;
        let FnameError = this.state.ErrorFirstname.length > 0;
        let LnameError = this.state.ErrorLastname.length > 0;
        let DobError = this.state.ErrorDob.length > 0;
        let EmailError = this.state.Erroremail.length > 0;
        return (
            <>
                {process.env.REACT_APP_MODE != "development" && <Helmet>
                    <title>Gulf Ticket : Profile</title>
                    <meta name="description" content="Gulf Ticket Profile" />
                </Helmet>
                }
                <div className="register myAccProfUpdate">
                    <div className="registerInr">
                        <form className="register-form" onSubmit={this.ProfileUpdate}>
                            <div className="formCont">
                                <label for="password">{t('lbluserid')}<small className="requiredSymbol">*</small></label>
                                <input type="text" className="form-control" id="txtpassword" placeholder={`${t('lblEnteruserid')}*`} name="regUserid" maxLength={15} autoComplete="off" disabled value={this.state.regUserid} onChange={this.handleChange} />
                            </div>
                            <div className="formCont">
                                <label for="FullName">{t('lblFirstName')}<small className="requiredSymbol">*</small></label>
                                <div class="countryCodes">
                                    <a class="countryImg" onClick={() => this.toggleVal()}><small class="regLble">{this.state.honorifics}</small></a>
                                    <ul class="selContry scrollbar" id="NewselContry">
                                        <li onClick={() => this.fstNameVal("Mr")}><a>Mr.</a></li>
                                        <li onClick={() => this.fstNameVal("Ms")}><a>Ms.</a></li>
                                        <li onClick={() => this.fstNameVal("Mrs")}><a>Mrs.</a></li>
                                    </ul>
                                </div>
                                <input type="text" className="inputMobile" id="txtfullname" placeholder={`${t('lblEnterFirstname')}*`} maxLength={30} autoComplete="off" name="player_name" value={this.state.player_name} onChange={this.handleChange} />
                                {FnameError && <div class="errorTxt">{this.state.ErrorFirstname}</div>}
                            </div>
                            <div className="formCont">
                                <label for="Lastname">{t('lblLastName')}<small className="requiredSymbol">*</small></label>
                                <input type="text" className={`form-control ${LnameError ? "errorBorder" : ""}`} id="txtlastname" placeholder={`${t('lblEnterLastname')}*`} name="last_name" maxLength={30} autoComplete="off" value={this.state.last_name} onChange={this.handleChange} />
                                {LnameError && <div class="errorTxt">{this.state.ErrorLastname}</div>}
                            </div>
                            <div className="formCont">
                                <label for="Dob">{t('lblDOB')}<small className="requiredSymbol">*</small></label>
                                <input type="text" className={`form-control daterange ${DobError ? "errorBorder" : ""}`} id="date-time1" placeholder="dd/mm/yyyy" maxLength={10} autoComplete="off" name="dob" />
                                {DobError && <div class="errorTxt">{this.state.ErrorDob}</div>}
                            </div>
                            {/* <div className="formCont">
                                <label for="password">{t('lblPwd')}<small className="requiredSymbol">*</small></label>
                                <input type="text" className="form-control" id="txtpassword" placeholder="************" name="password" maxLength={15} autoComplete="off" disabled value={this.state.password} onChange={this.handleChange} />
                            </div> */}
                            <div className="formCont">
                                <label for="Email">{t('lblEmail')}<small className="requiredSymbol">*</small></label>
                                <input type="text" className={`form-control ${EmailError ? "errorBorder" : ""}`} id="txtemail" placeholder={`${t('lblenterEmail')}*`} maxLength={50} autoComplete="off" name="email" value={this.state.email} onChange={this.handleChange} />
                                {EmailError && <div class="errorTxt">{this.state.Erroremail}</div>}
                            </div>

                            <div class="formCont">
                                <label>{t('lblContact')}<sup>*</sup></label>
                                <div class="countryCodes">
                                    {this.state.Ccname != "" &&
                                        <a className="countryImg">
                                            <img src={`${process.env.REACT_APP_CDN_URL}/assets/flags/${this.state.setCountryCode.replace("+", "")}.png?v0`} />
                                            {/* +{this.state.setCountryCode} */}
                                            {/* <small>{this.state.Ccname}</small> */}
                                            <small>+{this.state.setCountryCode}</small>
                                        </a>}
                                </div>
                                {this.state.mobnoLength != '' && <input type="text" className="inputMobile" id="" name="phone_no" value={this.state.phone_no} placeholder={t('lblMobileNo')} maxLength={this.state.mobnoLength} autoComplete="off" onChange={this.handleChange} disabled />}
                            </div>

                            <div class="formCont updateBtn">
                                <button className="btn2" type="submit">{t('lblUpdate')}</button>
                            </div>

                        </form>
                        {/* <div className="formContainer">
                            <a><b>{t('lblrefferal')} :</b> {`${process.env.REACT_APP_DESKTOP_URL}?plyrid=${this.props.user.referralid}`}</a>
                        </div> */}
                        {/* <div className="formContainer">
                            <a><b>{this.props.user.kycstatus == '0' ? "Kyc Not activated" : this.props.user.kycstatus == '1' ? "Kyc activated" : ""}</b> </a>
                        </div> */}
                    </div>
                </div >
            </>
        );
    }
}
function mapStateToProps(state) {
    const { user, appvariables } = state.loginReducer;
    const { details } = state.accountReducer;
    return { user, details, appvariables };
}
const mapActionToProps = {
    alertError: alertActions.error,
    GetProfile: accountActions.GetProfile,
    UpdateProfile: accountActions.UpdateProfile,
}
export default connect(mapStateToProps, mapActionToProps)(withTranslation()(Profile))